import React from 'react';
import PropTypes from 'prop-types';
import round from 'lodash/round';
import { ALL_ROWS_LABEL } from '../../mme/MMEConstants';

const MMECellContent = ({ cell, rowHeader, reportType, index }) => {
  return (
    <div className="c-table--col">
      <div className="cell-content">
        {reportType === 'SR' && <div className="cell-value">
          <div
            className={rowHeader === ALL_ROWS_LABEL ? 'mme-cell-value-first-row' : 'mme-cell-value-next-rows'}
            title={`${cell.p}%`}
            data-class={`p${index}`}
          >{`${cell.p}%`}
          </div>
        </div>}
        {reportType === 'DR' && <div className="cell-value">
          <div
            className={rowHeader === ALL_ROWS_LABEL ? 'mme-cell-value-first-row' : 'mme-cell-value-next-rows'}
            title={cell.s}
            data-class={`s${index}`}
          >{cell.s}
          </div>
        </div>}
        <div className="cell-value">
          <div
            className={rowHeader === ALL_ROWS_LABEL ? 'mme-cell-value-first-row' : 'mme-cell-value-next-rows'}
            title={round(cell.i)}
            data-class={`i${index}`}
          >{round(cell.i)}
          </div>
        </div>
        <div className="cell-value">
          <div
            className={rowHeader === ALL_ROWS_LABEL ? 'mme-cell-value-first-row' : 'mme-cell-value-next-rows'}
            title={cell.r}
            data-class={`r${index}`}
          >{cell.r}
          </div>
        </div>
      </div>
    </div>
  );
};

MMECellContent.propTypes = {
  cell: PropTypes.shape({
    r: PropTypes.number,
    i: PropTypes.number,
    p: PropTypes.number,
    s: PropTypes.number,
  }),
  rowHeader: PropTypes.string,
  highlightAndFilter: PropTypes.shape({
    sample: PropTypes.shape({}),
    weighted: PropTypes.shape({}),
    vertical: PropTypes.shape({}),
    horizontal: PropTypes.shape({}),
    index: PropTypes.shape({}),
  }),
  newHighlightAndFilter: PropTypes.shape({}),
  reportType: PropTypes.string,
  index: PropTypes.number,
};

export default MMECellContent;
